/* eslint-disable no-param-reassign */

import Vue from "vue";
import Vuex from "vuex";
import { get } from "../storage/storage";
import actions, { mapTokenize } from "./actions/actions";
import mutations from "./mutations/mutations";

Vue.use(Vuex);

const token = get("token") || "";

export default new Vuex.Store({
  state: {
    flow: [],
    basket: get("basket") || [],
    basketState: false,
    user: {
      token
    },
    drawing: {
      ratio: 1
    },
    devMode:
      window && window.location && window.location.href.indexOf(":8080") !== -1
  },
  mutations: {
    setToken: (s, t) => {
      s.user.token = t;
    },
    setDrawingRatio: (s, t) => {
      s.drawing.ratio = t;
    },
    ...mutations.flowMutations,
    ...mutations.basketMutations
  },
  actions: {
    ...mapTokenize(token, actions.kvActions),
    ...mapTokenize(token, actions.projectActions),
    ...mapTokenize(token, actions.partnerActions),
    ...mapTokenize(token, actions.contactActions),
    ...mapTokenize(token, actions.renderActions),
    ...actions.authActions,
    ...actions.flowActions,
    ...actions.basketActions,
    ...mapTokenize(token, actions.miscActions),
    ...mapTokenize(token, actions.pictureActions)
  },
  getters: {
    isAuthenticated: s => s.user.token !== "",
    token: s => s.user.token,
    isSelectedProject: s => id => s.selectedProject === parseInt(id, 10),
    selectedProject: s => s.selectedProject
  }
});
